import { render, staticRenderFns } from "./AStaffDetailApplyReturnFee.vue?vue&type=template&id=32ace97c&scoped=true"
import script from "./AStaffDetailApplyReturnFee.vue?vue&type=script&lang=js"
export * from "./AStaffDetailApplyReturnFee.vue?vue&type=script&lang=js"
import style0 from "./AStaffDetailApplyReturnFee.vue?vue&type=style&index=0&id=32ace97c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ace97c",
  null
  
)

export default component.exports